export var MOBILE_WIDTH = 426;
export var TABLET_WIDTH = 768;
export var SMALL_LAPTOP_WIDTH = 1024;



//////////////////
// WEBPACK FOOTER
// ./src/utils/constants.ts
// module id = 58
// module chunks = 0